import 'slick-carousel';
import { resizeBackgroundImages } from '../utilities/responsive-images';

const $win = $(window);
const $doc = $(document);

const sliderOptions = {
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: false,
	asNavFor: '#product .product__thumbs',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				dots: true
			}
		}
	]
}

const thumbsOptions = {
	slidesToShow: 6,
	slidesToScroll: 6,
	dots: false,
	arrows: false,
	infinite: false,
	asNavFor: '#product .product__slider',
	focusOnSelect: true
}

$('#product .product__slider').slick(sliderOptions);
$('#product .product__thumbs').slick(thumbsOptions);

$doc.on('shopify:section:load', function(event) {
	$('#product .product__slider').slick(sliderOptions);
	$('#product .product__thumbs').slick(thumbsOptions);
})

$('#product .product__slider, #product .product__thumbs').each((index, slider) => {
  handleLazyLoad(slider);
});

function handleLazyLoad(slider) {
  const sliderImages = slider.querySelectorAll('.responsive-background-image');
  const $slider = $(slider);

  $slider.on('refresh afterChange', function () {
    resizeBackgroundImages(sliderImages);
  });
}

$('#product .product__thumbs, #product .product__slider').on('setPosition', function () {
	$(this).find('.slick-slide').height('auto');
	var slickTrack = $(this).find('.slick-track');
	var slickTrackHeight = $(slickTrack).height();
	$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
});